import request from '@/utils/request';


export function listDevice(query: object) {
    return request({
     // url: '/resource/bill/list',
     url:'/source/type/currentId',
      method: 'get',
      params: query,
    });
}
// 新增设备
export function addDevice(query) {
    return request({
        url: '/resource/bill/add',
      method: 'post',
      data: query,
    });
}
// 编辑设备
export function updateDevice(query) {
    return request({
        url: '/resource/bill/edit',
      method: 'post',
        data: query,
    });
}
// 删除设备
export function delDevice(id) {
    return request({
      url: '/resource/bill/delete/' + id,
      method: 'delete',
    });
}

// 新增系统分类等
export function addSystem(query) {
    return request({
        url: '/source/type/add',
      method: 'post',
        data: query,
    });
}
// 获取设备类型
export function equipmentType(equipmentId: string) {
    return request({
        url: '/equipment/device/type/' + equipmentId,
      method: 'get',
    });
}
// 获取设备名称
export function equipmentName(typeId: string) {
    return request({
        url: '/equipment/device/equipmentName/' + typeId,
      method: 'get',
    });
}
// 获取计量单位
export function unit() {
    return request({
        url: '/equipment/device/unit',
      method: 'get',
    });
}
// 获取树结构列表
export function getEquipment() {
    return request({
        url: '/source/type/list',
      method: 'post',
    });
}
